import React from 'react';
import type { FC } from 'react';
import { Box, Text, Link, Cart, Statistics } from '@wix/cli-ui-kit';
import { Trans } from '@wix/cli-i18n';
import { useProjectModel } from '../../../model.js';

export const NextSteps: FC = () => {
  const {
    model: {
      config: { appId },
    },
  } = useProjectModel();

  const homeUrl = `https://dev.wix.com/apps/${appId}/home?referralInfo=wix-cli`;
  const statisticsUrl = `https://dev.wix.com/apps/${appId}/statistics?referralInfo=wix-cli`;

  return (
    <Box flexDirection="column" gap={1}>
      <Text bold>
        <Trans i18nKey="release_command.next_steps" />
      </Text>
      <Trans
        i18nKey="release_command.open_stats"
        components={[<Statistics />, <Link url={statisticsUrl} />]}
      />
      <Trans
        i18nKey={'release_command.distribute'}
        components={[<Cart />, <Link url={homeUrl} />]}
      />
    </Box>
  );
};
